<template>
    
    <div>
        <nav class="p-2 border-bottom border-primary">
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraListaImpianti"
            >Lista Impianti</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraPaginaUtentiPendenti"
            >Lista Utenti in attesa validazione</b-button>
            <b-button
            :pressed="false"
            class="typo-label"
            variant="link"
             @click="mostraPaginaUtenti"
            >Lista Utenti</b-button>
            <b-button
            :pressed="true"
            class="typo-label"
            variant="link"
            >Gestione Codici Pro</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'"
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraRiepilogo"
            >Riepilogo</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'" 
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraMappa"
            >Mappa</b-button>
            <b-button v-if="this.$store.state.user.email=='aws.dev@beghelli.it' || this.$store.state.user.email=='aws.prod@beghelli.it'"
            :pressed="false"
            class="typo-label"
            variant="link"
            @click="mostraAldi"
            >Report Aldi</b-button>
        </nav>
        <Loader />
        <div v-if="!authorized && !pageloading" class="mt-4 center">
            <h3>Non sei autorizzato ad accedere a questa risorsa</h3>
        </div>
        <div v-if="!pageloading && authorized" class="animated fadeIn container-fluid">
            <b-row>
                <b-col md="3" lg="4" class="py-4 text-center">
                    <b-row>
                        <b-col><div class="pt-2">Mostra codici Pro: </div></b-col>
                        <b-col>
                            <b-form-select style="width: 100%" v-model="filters.activatedToken">
                            <b-form-select-option value="">Tutti</b-form-select-option>
                            <b-form-select-option value="activated">Solo attivati</b-form-select-option>
                            <b-form-select-option value="notactivated">Non ancora attivati</b-form-select-option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7" lg="5" offset-lg="1" class="py-4 text-center">
                    <b-form-group>
                        <b-input-group>
                        <!-- Attach Left button -->
                        <b-input-group-prepend>
                            <b-input-group-text>Cerca:</b-input-group-text>
                            
                        </b-input-group-prepend>
                        <b-form-input type="text" placeholder="" v-model="searchFilter"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary">
                                <i class="fa fa-search"></i>
                            </b-button>
                        </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="2" lg="2" class="py-2 text-center">
                     <b-button class="typo-butt-add mt-3 mr-1 but-add" v-b-modal.modal-procode> 
                        {{$t("generate_procode_button.text")}}
                    </b-button>
                    <b-modal id="modal-procode" title="Genera Codice" ok-title="Genera" ok-only @ok="handleOk">
                        <b-form-group>
                            <label for="label-pro-qta">Quantità</label>
                            <b-form-input :id="`type-number`" type="number" min=1 v-model="tokenQta"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label for="label-pro-type">Tipologia</label>
                            <b-form-select v-model="proType">
                                <option value="pro">Pro</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group>
                            <label for="label-duration-type">Durata</label>
                            <b-form-select v-model="durType">
                                <option value="onemonth">1 mese</option>
                                <option value="threemonth">3 mesi</option>
                                <option value="sixmonth">6 mesi</option>
                                <option value="oneyear">1 anno</option>
                                <option value="threeyear">3 anni</option>
                                <option value="fiveyear">5 anni</option>
                                <option value="tenyear">10 anni</option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group>
                            <label for="label-pro-note">Nota</label>
                            <b-form-input v-model="tokenNote"></b-form-input>
                        </b-form-group>
                    </b-modal>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col class="center">
                    <b-table id="ntoTable" :per-page="rpp" :current-page="tabPage" sticky-header="500px" 
                        :striped="true" :hover="true" :items="filteredList" :fields="tableFields" 
                        :outlined="true" sort-icon-left>

                        <template v-slot:cell(token)="tk">
                            <b-row>
                                <b-col class="text-left mt-1">
                                    {{ tk.value }}
                                </b-col>
                                <b-col class="text-right">
                                    <button class="typo-butt-cop but-cop"
                                        v-clipboard:copy="tk.value"
                                        v-clipboard:success="onCopy">                                        
                                        <i class="fa fa-clipboard"></i>
                                    </button>
                                </b-col>
                            </b-row>
                        </template>

                        <template v-slot:cell(dateCreation)="dataC">
                            {{ dataCod(dataC.value)}}
                        </template>

                        <template v-slot:cell(dateUsed)="dataU">
                            {{ dataCod(dataU.value)}}
                        </template>

                        <template v-slot:cell(plantId)="plID">
                            {{ plantCod(plID.value)}}
                        </template>

                        <template v-slot:cell(plantName)="plName">
                            {{ plantCod(plName.value)}}
                        </template>

                        <template v-slot:cell(note)="tokNote">
                            {{ noteCod(tokNote.value)}}
                        </template>



                    </b-table>
                </b-col>
            </b-row>
            <b-navbar v-if="allTokens != null && allTokens.length > 0" type="light" fixed="bottom" class="bottomNav"> 
                <b-nav-text class="mx-auto">
                    <span class="totLabel">Totale records filtrati: {{filteredList.length}}</span>
                    <b-pagination
                        v-model="tabPage"
                        :total-rows="filteredList.length"
                        :per-page="rpp"
                        aria-controls="ntoTable"
                        ></b-pagination>
                </b-nav-text>
            </b-navbar>
        </div>
    </div>

</template>

<script>

import { Auth } from 'aws-amplify'
import { API } from 'aws-amplify'
//import * as Axios from 'axios'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import { mapState, install } from 'vuex';
import { uuid } from 'vue-uuid'; 
import moment from 'moment'
import router from '../router/approuter'
import {showAt, hideAt} from 'vue-breakpoints'


export default {
    name: 'NTOProCodes',
    components: {
        hideAt, showAt

    },    
    props: [],
    data() {
        return {
            userId: null,
            pageloading: true,
            searchFilter: "",
            authorized: false,
            dataLoaded: false,
            allTokens: [],
            tabPage: 1,
            rpp: 50,
            filters: {
                activatedToken: ''
            },
            tableFields: [
                {
                    key: 'token',
                    label: 'Codice',
                    sortable: false
                },
                {
                    key: 'tokenType',
                    label: 'Tipo Codice',
                    sortable: false
                },
                {
                    key: 'dateCreation',
                    label: 'Creato in data',
                    sortable: true
                },
                {
                    key: 'dateUsed',
                    label: 'Attivato in data',
                    sortable: true
                },
                {
                    key: 'plantId',
                    label: 'ID Impianto',
                    sortable: true
                },
                {
                    key: 'plantName',
                    label: 'Nome Impianto',
                    sortable: true
                },
                {
                    key: 'duration',
                    label: 'Durata (mesi)',
                    sortable: true
                },
                {
                    key: 'note',
                    label: 'Note',
                    sortable: false
                }

            ],
            tokenQta: 1,
            tokenNote:'',
            proType: "pro",
            durType: "onemonth",
        }
    },
    created() {
        
    },
    mounted() {
        
            
            console.log("MOUNTED NTOProCodes " + this.pageloading + ", proCodes:" + this.$store.state.allTokens);
        
            if (!this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected) {
                //this.$store.dispatch('loadAllPlants',  this.$route.params.userId);
                const usertype = this.$store.getters.userType;
                console.log("ntoprocodes launch loadAllTokens, " + usertype);
                if (usertype != 'admin') {
                    this.authorized = false;
                    this.pageloading = false;
                } else {
                    this.authorized = true;
                    this.pageloading = true; 
                    this.dataLoaded = true;
                    this.$store.dispatch('loadAllTokens', {userId: this.$store.state.user.username});
                }
            } 

        
    },
    updated() {
        
        console.log("updated ntoprocodes");
        
    },
    computed: {
         ...mapState(['loading']),
         filteredList() {

            var records = this.allTokens.filter(token => token.tokenType == 'pro');
            
            if (this.filters.activatedToken=="activated")
            {

                records = this.allTokens.filter(token => {
                    return token.dateUsed!="null";
                })
            }

            if (this.filters.activatedToken=="notactivated")
            {

                records = this.allTokens.filter(token => {
                    return token.dateUsed=="null";
                })
            }

            if (this.searchFilter != '') 
            {
            records = this.allTokens.filter(token => {
                console.log("token:",token.plantName);
                return ((token.token ||'').toLowerCase().includes(this.searchFilter.toLowerCase()) 
                    || (token.dateUsed ||'').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || (token.plantId || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    || (token.plantName || '').toLowerCase().includes(this.searchFilter.toLowerCase())
                    )
                })
            }

            console.log("RECORDS",records);
            return records;
         }
    },  
     watch: {
        loading(val,oldval) {
            console.log("ntousers loading changed:" + val+ ", authorized=" + this.authorized+", pageLoading:" + this.pageloading);
            
            if (val == false && this.pageloading == true) {
                let self = this;
                if (! this.dataLoaded) {
                    const usertype = this.$store.getters.userType;
                    if (usertype == 'admin') {
                        this.authorized = true;
                        this.pageloading = true;
                        this.dataLoaded = true;
                        this.$store.dispatch('loadAllTokens', {userId: this.$store.state.user.username});
                    }
                    return;
                }
                this.allTokens = this.$store.state.allTokens.filter(user => {
                        return user.id != self.$store.state.user.username;
                });
                
                let allPlants = this.$store.state.userAllPlants;
                console.log("userAllPlants2:", allPlants);
                this.allTokens.forEach(function(t) {
                    console.log("token " + t.plantId);
                    if (t.plantId != null && t.plantId != "" && t.plantId != "null") {
                        let p = allPlants.find(function(pl) { 
                            return pl.id == t.plantId}
                        );
                        if (p != null) t.plantName = p.plantname;
                    }
                });

                this.pageloading = false;
            }
        }
     },        
    methods: {
        
        mostraListaImpianti() {
            router.push({ name: 'NTOHome'})
        },
        mostraPaginaUtentiPendenti() {
            router.push({ name: 'NTOPendingUsers'})
        },
        mostraPaginaUtenti() {
            router.push({ name: 'NTOUsers'})
        },        
        mostraRiepilogo() {
            router.push({ name: 'NTOSummary'})
        },
        mostraMappa() {
            router.push({ name: 'NTOPlantsMap'})
        },
        mostraAldi() {
            router.push({ name: 'NTOAldi'})
        },
        loadAllTokens() {
            this.$store.dispatch('loadAllTokens',{userId: this.$store.state.user.username});
        },
        dataCod(ts) {
            if(ts == "null" || ts=="")
                return "";
            else
                return moment(String(ts)).format('DD/MM/YYYY');
        },
        noteCod(not) {
            console.log("NOT:",not);
            if(not == null || not =="")
                return "";
            else
                return not;
        },
        plantCod(pl) {
            if(pl == "null")
                return "";
            else
                return pl;
        },
        async handleOk(){
            var newTokens = [];
            var i = this.tokenQta;
            while (i > 0) {
                var id = ("" + uuid.v1()).replaceAll("-","").toUpperCase().substr(0,16);
                var jsonToken = `{"token":"${id}",
                    "tokenType":"${this.proType}",
                    "dateUsed":"null",
                    "plantId":"null",
                    "plantName":"null",
                    "duration":"${this.getDuration(this.durType)}",
                    "dateCreation":"${(new Date()).toISOString()}", 
                    "note":"${this.tokenNote}"
                }`;
                
                newTokens.push(JSON.parse(jsonToken));
                i--;
            }

            console.log("new Token to insert:",newTokens);
            // call generateTokens
            var result = await this.$store.dispatch('createTokens', newTokens);
            console.log("create Token result:",result);
            if(result.data == "error")
                alert('Errore nella generazione');

            //this.loadAllTokens();
            this.$nextTick(() => {
                this.pageloading = true; 
                this.dataLoaded = true;
                this.$store.dispatch('loadAllTokens', {userId: this.$store.state.user.username});
            });
            
        },
        getDuration(dur){
            switch (dur) {
                case "onemonth":
                    return 1;                    
                case "threemonth":
                    return 3;
                case "sixmonth":
                    return 6;
                case "oneyear":
                    return 12;                    
                case "threeyear":
                    return 36;
                case "fiveyear":
                    return 60;
                case "tenyear":
                    return 120;
                default:
                    break;
            }
        },
        getDate() {
            var d = new Date();
            var data = d.getFullYear() + "-" + (d.getMonth()+1) + "-" + d.getDate();
            var h = "0" + d.getHours();
            var m = "0" + d.getMinutes();
            var s = "0" + d.getSeconds();
            var ora =  h.substring(h.length-2) + ":" + m.substring(m.length-2) + ":" + s.substring(s.length-2);
            return data + "T" + ora + ".000Z";
        },
        onCopy: function (e) {
            alert('Codice copiato!')
        }
    }

}
</script>

<style lang="scss" scoped>
    .bottomNav {
        bottom:60px;
        //background-color: #fff;
    }
    .totLabel {
        font-family: 'Roboto',sans-serif;
        font-size: 14px;
        font-weight: bold;
        color: #333;
    }
    #copyToClipboard {
        border-radius: 0px;
    }
    .but-cop{
        height: 30px;
        background: transparent linear-gradient(270deg, #007FB4 0%, #009DE0 100%) 0% 0% no-repeat padding-box;
        border-radius: 29px;
        opacity: 1;
        border: 0px;
    }
    .typo-butt-cop{
        color: #FFFFFF;
        font-family: 'Roboto';
        font-size: 13px
    }
    

</style>